import { createSelector, createSlice } from "@reduxjs/toolkit";
import { BuyRequestStatus } from "../../../constants/enums";

export const swarmsSlice = createSlice({
    name: "swarms",
    initialState: { events: null, swarms: null, buyRequests: null, rewardType: null, resolutionType: null, strategyType: null, disapprovalReason: null, lostReason: null, deliveryMethods: null, pendingBuyRequestGrid: [] },
    reducers: {
        setSwarms: (state, action) => { // * You should do not use this action because you would be overriding the whole swarms array, use updateSwarms instead
            state.swarms = action.payload
        },
        setEvents: (state, action) => { // * You should do not use this action because you would be overriding the whole events array, use updateEvents instead
            state.events = action.payload
        },
        setBuyRequests: (state, action) =>{
            state.buyRequests = action.payload
        },
        //set disapprovalReason
        setDisapprovalReason: (state, action) => {
          state.disapprovalReason = action.payload
        },
        setLostReason: (state, action) => {
          state.lostReason = action.payload
        },
        updateSwarms: (state, action) => {
            const swarms = action.payload;
            if(state.swarms == null || state.swarms == undefined){
              console.log("updateSwarms, swarms: " + JSON.stringify(swarms) + " store is null adding swarm, OK");
              state.swarms= swarms;
              return;
            }
            swarms.forEach(swarm => {
              const swarmIndex = state.swarms.findIndex((s) => s.id === swarm.id);
              if (swarmIndex !== -1) {
                state.swarms[swarmIndex] = swarm;
              } else {
                state.swarms.push(swarm);
              }
            });
        },
        updateEvents: (state, action) => {
            const events = action.payload;
            console.log("updateEvents, events: ", JSON.stringify(events));
            if(state.events == null || state.events == undefined){
              console.log("updateEvents, events: ", JSON.stringify(events), " store is null adding events, OK");
              state.events = events;
              return;
            }
            events.forEach(event => {
              const eventIndex = state.events.findIndex((e) => e.bteId === event.bteId);
              if (eventIndex !== -1) {
                state.events[eventIndex] = event;
              } else {
                state.events.push(event);
              }
            }
            );
            console.log("updateEvents, events updated: ", JSON.stringify(state.events));
          },
        updateBuyRequest: (state, action) => {
          const buyRequest = action.payload;
          const buyRequestIndex = state.buyRequests.findIndex(s => s?.id && buyRequest?.id && s?.id === buyRequest?.id);
          state.buyRequests[buyRequestIndex] = buyRequest;
        },
        updateBuyRequests: (state, action) => {
          const incommingBuyRequests = action.payload;
          
          if(state.buyRequests === null) state.buyRequests = [];
          incommingBuyRequests.forEach(buyRequest => {
            const buyRequestIndex = state.buyRequests.findIndex(s => s?.id && buyRequest?.id && s?.id === buyRequest?.id);
            if (buyRequestIndex !== -1) {
              state.buyRequests[buyRequestIndex] = buyRequest;
            } else {
              state.buyRequests.push(buyRequest);
            }
          });

        },
        addBuyRequests: (state, action) => {
          const buyRequest = action.payload;
          if(state.buyRequests === null) state.buyRequests = [];
          state.buyRequests.push(buyRequest);
        },
        addBuyRequestsSafe: (state, action) => {
          const buyRequest = action.payload;
          if(state.buyRequests === null) state.buyRequests = [];
          const buyRequestIndex = state?.buyRequests?.findIndex((s) => s?.id && s?.id === buyRequest.id);
          if(buyRequestIndex != -1) return; //A: the buy request already exist in store, do nothing;
          state.buyRequests.push(buyRequest);
        },
        addBuyRequestsArrSafe: (state, action) => {
          const buyRequests = action.payload;
          if(state.buyRequests === null) state.buyRequests = [];
          const newItems = buyRequests.filter(br => state?.buyRequests?.findIndex((s) => s?.id && s?.id === br.id) === -1);
          state.buyRequests.push(...newItems);
        },
        setRewardType: (state, action) => {
            state.rewardType = action.payload
        },
        setResolutionType: (state, action) => {
            state.resolutionType = action.payload
        },
        setStrategyType: (state, action) => {
            state.strategyType = action.payload
        },
        setDelyveryMethods: (state, action) => {
            state.deliveryMethods = action.payload
        },
        updateSwarm: (state, action) => {
            const swarm = action.payload;
            
            if(state.swarms == null || state.swarms == undefined){
              console.log("updateSwarm, swarm: " + swarm.id + " store is null adding swarm, OK");
              state.swarms= [swarm];
              return;
            }

            const swarmIndex = state?.swarms?.findIndex((s) => s.id === swarm.id);
            
            if (swarmIndex !== -1) {
              state.swarms[swarmIndex] = swarm;
            } else {
                state.swarms.push(swarm);
            }
        },
        updateSwarmSoftClosing:(state,action)=>{
          console.log("updateSwarmSoftClosing: ", action.payload)
          const swarm = action.payload;
            
          if(state.swarms == null || state.swarms == undefined){
            console.log("updateSwarm, swarm: " + swarm.id + " store is null adding swarm, OK");
            state.swarms= [swarm];
            return;
          }

          const swarmIndex = state?.swarms?.findIndex((s) => s.id === swarm.id);
          
          if (swarmIndex !== -1) {
            if(state.swarms[swarmIndex].running && !swarm.running){ // swarm has been closed
              // used to notify the bee
              let inMemorySwarm = {...swarm, running:true, hasBeenClosed: true }
              state.swarms[swarmIndex] = inMemorySwarm;
              console.log("updateSwarmSoftClosing: swarm has been closed: ", inMemorySwarm)
            }else{
              // just update the swarm
              console.log("updateSwarmSoftClosing: swarm has not been closed: ", swarm)
              state.swarms[swarmIndex] = swarm;
            }
          } else {
            console.log("updateSwarmSoftClosing: swarm not found in store, adding it: ", swarm)
              state.swarms.push(swarm);
          }
        },
        addSwarmSafe: (state, action) => {
          const swarm = action.payload;
          if(state.swarms == null || state.swarms == undefined){
            console.log("addSwarmSafe, swarm: " + swarm.id + " store is null adding swarm, OK");
            state.swarms= [swarm];
            return;
          }
          const swarmIndex = state?.swarms?.findIndex((s) => s.id === swarm.id);
          if (swarmIndex !== -1) {
            console.log("addSwarmSafe, swarm: " + swarm.id + " exists in store, DROP");
          } else {
            console.log("addSwarmSafe, swarm: " + swarm.id + " not exists in store, OK");
            state.swarms.push(swarm);
          }
        },
        addEventSafe: (state, action) => {
          const event = action.payload;
          console.log("addEventSafe, event: ", event);
          if(state.events == null || state.events == undefined){
            console.log("addEventSafe, event: " + event.bteId + " store is null adding swarm, OK");
            state.events= [event];
            return;
          }
          const eventIndex = state?.events?.findIndex((s) => s.bteId === event.bteId);
          if (eventIndex !== -1) {
            console.log("addEventSafe, event: " + event.bteId + " exists in store, DROP");
          } else {
            console.log("addEventSafe, event: " + event.bteId + " not exists in store, OK");
            state.events.push(event);
          }
        },
        editSwarmForStop: (state, action)=>{
          // hot fix for stop swarm
          const swarm = action.payload;
          if(state.swarms == null || state.swarms == undefined){
            console.log("editSwarmForStop, swarm: " + swarm.id + " store is null adding swarm, OK");
            state.swarms= [swarm];
            return;
          }

          const swarmIndex = state.swarms.findIndex((s) => s.id === swarm.id);
          
          if (swarmIndex !== -1) {
            state.swarms[swarmIndex] = swarm;
          } else {
            state.swarms.push(swarm);
          }
        }
    }
});

export default swarmsSlice.reducer

export const selectAllEvents = state => state.swarmsSlice.events;
export const selectRunEvents = state => state.swarmsSlice.events?.filter(e => e.useRunLevelLimit)
export const selectAllSwarms = state => state.swarmsSlice.swarms;
export const getSwarmById = (state, id) => state.swarmsSlice.swarms?.find(s => s.id === id);
export const getEventById = (state, id) => state.swarmsSlice.events?.find(e => e.id === id);
export const selectAllActiveSwarms = state => state.swarmsSlice.swarms?.filter(s => s.running === true);
export const selectAllBuyRequests = state => state.swarmsSlice.buyRequests;
export const selectVisibleBuyRequests = state => state.swarmsSlice.buyRequests
                ?.filter(BR => parseInt(BR?.createdBy) === parseInt(state.auth?.user?.id))
                ?.filter(BR => !BR?.acknowledge)
                ?.filter( BR =>
                    BR?.swarmResolutionTypeId === BuyRequestStatus.Accepted
                      ||
                    BR?.swarmResolutionTypeId === BuyRequestStatus.Rejected
                      ||
                    BR?.swarmResolutionTypeId === BuyRequestStatus.Pending
                      ||
                    BR?.swarmResolutionTypeId === BuyRequestStatus.OverTheLimit
                  )
export const selectRewardType = state => state.swarmsSlice.rewardType;
export const selectResolutionType = state => state.swarmsSlice.resolutionType;
export const selectStrategyType = state => state.swarmsSlice.strategyType;
export const selectDisapprovalReason = state => state.swarmsSlice.disapprovalReason;
export const selectLostReason = state => state.swarmsSlice.lostReason;
export const selectAllReasons = state => {
  const disapprovalReasonPrev = state.swarmsSlice.disapprovalReason ?? [];
  const lostReasonPrev = state.swarmsSlice.lostReason ?? [];
  const disapprovalReason = [...disapprovalReasonPrev];
  const lostReason = [...lostReasonPrev];
  return [...disapprovalReason, ...lostReason];
}
export const selectDeliveryMethods = state => state.swarmsSlice.deliveryMethods;
export const selectAllEventsRunning = state => {
    const swarms = state.swarmsSlice.swarms;
    const events = state.swarmsSlice.events;
  
    if (!swarms || !events) {
      return null;
    }
  
    const runningSwarms = swarms.filter(swarm => swarm.running === true);
    const eventIds = runningSwarms.map(swarm => swarm.bteId);
    const filteredEvents = events.filter(event => eventIds.includes(event.id));
  
    return filteredEvents;
  };

// Selector to get all pending buy requests for a given swarm ID
export const selectPendingBuyRequestsForSwarm = createSelector(
  [
    (state) => state.swarmsSlice.buyRequests, // All buy requests from the swarmsSlice
    (_, swarmId) => swarmId                    // The swarm ID passed as a parameter
  ],
  (buyRequests, swarmId) => {
    if (!buyRequests) return [];
    // Filter buy requests that belong to the given swarm and have a pending status
    return buyRequests.filter(
      (br) => br.swarmId === swarmId && br.swarmResolutionTypeId === BuyRequestStatus.Pending
    );
  }
);

// Selector that returns true if the given swarm has any pending buy requests
export const selectHasPendingBuyRequestsForSwarm = createSelector(
  [selectPendingBuyRequestsForSwarm],
  (pendingBuyRequests) => pendingBuyRequests.length > 0
);

export const {
  updateEvents,
  updateSwarm,
  updateSwarms,
  updateSwarmSoftClosing,
  updateBuyRequest,
  updateBuyRequests,
  setDisapprovalReason,
  setLostReason,
  addSwarmSafe,
  addEventSafe,
  setBuyRequests,
  setRewardType,
  setResolutionType,
  setStrategyType,
  addBuyRequests,
  addBuyRequestsSafe,
  addBuyRequestsArrSafe,
  editSwarmForStop,
  setDelyveryMethods,
} = swarmsSlice.actions;
